<!--下载组件模块-->
<template>
    <div>
        <!--按钮主体-->
        <button :class="btnStyle" :style="fstyle" @click="downLoadAction">
            <slot></slot>
        </button>
        <a download ref="downLoadDom" v-show="false" target="_Self"></a>
    </div>
</template>

<script>
export default {
    name:'poi-download',
    data () {
        return {
        }
    },
    props: {
       //接收按钮类型  
        type: {
            type:String,
            default: () => {
                return 'default'
            }
        },
        //接收按钮大小
        size:{
            type:String,
            default: () => {
                return 'default'
            }
        },
        //接收自定义属性
        freestyle:{
            type:null
        },
        //接收文件名
        fileName:{
            type:String,
            default: () => {
                return ''
            }
        },
        //接收请求url
        loadUrl:{
            type:String,
            default: () => {
                return ''
            }
        },
        //接收请求方式
        loadMethod:{
            type:String,
            default: () => {
                return 'get'
            }
        },
        //接收请求参数
        loadParameter:{
            type:Object,
            default: () => {
                return {}
            }
        },
    },
    computed:{
         //匹配按钮样式
         btnStyle(){
            let list = []
            if(this.type!='text'){
                list.push('poi-btn');
            }
            //匹配按钮类型
            switch(this.type){
                case 'primary':
                    list.push('poi-btn-primary');
                    break;

                case 'success':
                    list.push('poi-btn-success');
                    break;

                case 'info':
                    list.push('poi-btn-info');
                    break;

                case 'warning':
                    list.push('poi-btn-warning');
                    break;

                case 'danger':
                    list.push('poi-btn-danger');
                    break;

                case 'text':
                    list.push('poi-btn-text');
                    break;    

                default:
                    list.push(this.type);      
            }   
            //匹配按钮大小类型
            switch (this.size) {
                case 'small':
                    //小型
                    list.push('poi-btn-small');
                    break;
                case 'mini':
                    //迷你
                    list.push('poi-btn-mini');
                    break;
                case 'medium':
                    //中等
                    list.push('poi-btn-medium');
                    break;
                default:
                    //默认
                    list.push('default');          
            }

            return list;
        },
        //将自定义样式加入到属性中
        fstyle(){
            if(this.freestyle){
               var styleEl = document.styleSheets[1];
                this.freestyle.btnstyle.forEach((item,index) => {
                    styleEl.insertRule(item,styleEl.rules.length);
                }); 
            }
        }
    },
    methods:{
   
        // 下载动作
        downLoadAction(){
            let url = this.loadUrl;
            let xhr = new XMLHttpRequest();
            xhr.responseType = "blob";
            if(this.loadMethod == "get"){
                this.getMethodToLoad(url,xhr);
            }else{
                this.postMethodToLoad(url,xhr);
            }
        },

        // get方式下载
        getMethodToLoad(url,xhr){
            let that = this;
            xhr.open("GET", url, true);
            xhr.setRequestHeader("Authorization", localStorage.accessToken);
            //3.设置回调函数
            xhr.onload = function() {
            if (this.status == 200) {
                let me = this.response;
                that.openURL(this.response, that.fileName);
            } else {
                that.$message.error("下载失败");
            }
            };
            //4.发送请求
            // 要发送的参数，要转化为json字符串发送给后端，后端就会接受到json对象
            xhr.send();
        },

        // post方式下载
        postMethodToLoad(url,xhr){
            let that = this;
            xhr.open("POST", url, true);
            xhr.setRequestHeader("Authorization", localStorage.accessToken);
            //3.设置回调函数
            xhr.onload = function() {
                if (this.status == 200) {
                    let me = this.response;
                    that.openURL(this.response, that.fileName);
                } else {
                    that.$message.error("下载失败");
                }
            };
            //4.发送请求
            // 要发送的参数，要转化为json字符串发送给后端，后端就会接受到json对象
            xhr.send(JSON.stringify(this.loadParameter));
            // xhr.send();
        },

        // 模拟下载
        openURL(urldata, filename) {
            var blob = new Blob([urldata]);
            var objectUrl = window.URL.createObjectURL(blob);
            this.$refs.downLoadDom.href = objectUrl;
            this.$refs.downLoadDom.download = filename;
            this.$refs.downLoadDom.click();
        },
    }, 
}
</script>

<style  scoped>

</style>
